import React, { useEffect } from 'react'
import { Spinner } from 'react-bootstrap'
import { useNavigate, useParams } from 'react-router-dom'
import { documentService } from '../../services/document.service'

const DocumentASN: React.FC = () => {
  const { asn } = useParams<{ asn: string }>()
  const navigate = useNavigate()

  useEffect(() => {
    if (asn) {
      // Filter documents by ASN using the document service
      // Note: This requires implementing filtering by ASN in the document service
      documentService
        .getDocuments({ archive_serial_number: asn })
        .then((response) => {
          if (response.count === 1 && response.results.length === 1) {
            navigate(`/documents/${response.results[0].id}`, { replace: true })
          } else {
            navigate('/404', { replace: true })
          }
        })
        .catch(() => {
          navigate('/404', { replace: true })
        })
    }
  }, [asn, navigate])

  return (
    <div className="d-flex align-items-center justify-content-center" style={{ minHeight: '200px' }}>
      <div>
        <Spinner animation="border" className="me-2" />
        <span>Searching document with ASN {asn}</span>
      </div>
    </div>
  )
}

export default DocumentASN
